import React, { createContext, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import Top from "./ScreenAuth/Top";
import SignUp from "./ScreenAuth/SignUp";
import SignUpCode from "./ScreenAuth/SignUpCode";
import SignIn from "./ScreenAuth/SignIn";
import SignInCode from "./ScreenAuth/SignInCode";
import Privacy from "./ScreenAuth/Privacy";
import Contact from "./ScreenAuth/Contact";
import Sending from "./ScreenAuth/Sending";
import Welcome from "./ScreenAuth/Welcome";
import Tos from "./ScreenAuth/Tos";

// MEMO(2026-09-09 復元時): /dashBoard ルートは元からコメントアウトされており、
// 元ビルドにも画面本体のコードは含まれていない。ファイルを復元できないため読み込みを無効化。
// import DashBoard from "./Screen/DashBoard";
import HistoriesOrderings from "./Screen/HistoriesOrderings";
import HistoriesOrders from "./Screen/HistoriesOrders";
import HistoriesTransactions from "./Screen/HistoriesTransactions";
import HistoriesAffiliates from "./Screen/HistoriesAffiliates";

import Helmet1 from "../modules/Loading/Helmet1";

import RecoveryPw from "./ScreenAuth/RecoveryPw";
import RecoveryPwCode from "./ScreenAuth/RecoveryPwCode";
import InitializePw from "./ScreenAuth/InitializePw";

import ExchMarket from "./Screen/ExchMarket";
// MEMO(2026-09-09 復元時): 元のビルド成果物に ExchSimple のコードは含まれておらず、
// 下の /exch-simple ルートも元からコメントアウトされている（=画面として使われていない）。
// ファイル本体を復元できないため読み込みを無効化した。ルートを復活させる場合は要作成。
// import ExchSimple from "./Screen/ExchSimple";
import ExchAdvanced from "./Screen/ExchAdvanced";

import Pay from "./Screen/Pay";
import Settings from "./Screen/Settings";

import Sidebar from "./Screen/Sidebar";

import { useDispatch, useSelector } from "react-redux";

import PushTop from "./Top";
import AccountInfo from "./AccountInfo";

export const AppRouter = () => {
  const hist = createBrowserHistory();

  return (
    <>
      <Router history={hist}>
        <Switch>
          <Route exact path="/" component={PushTop} />
          <Route path="/top" render={(props) => <Top {...props} />} />
          {/* 強制送還 */}
          {/* <Redirect to="/top" /> */}

          <Route path="/signup/:rc" render={(props) => <SignUp {...props} />} />
          <Route path="/signup" render={(props) => <SignUp {...props} />} />
          <Route path="/signin" render={(props) => <SignIn {...props} />} />
          <Route
            path="/signupcode"
            render={(props) => <SignUpCode {...props} />}
          />
          <Route
            path="/signincode"
            render={(props) => <SignInCode {...props} />}
          />
          <Route path="/privacy" render={(props) => <Privacy {...props} />} />
          <Route path="/contact" render={(props) => <Contact {...props} />} />
          <Route path="/sending" render={(props) => <Sending {...props} />} />
          <Route path="/welcome" render={(props) => <Welcome {...props} />} />
          <Route path="/tos" render={(props) => <Tos {...props} />} />

          <Route
            path="/initialize-pw"
            render={(props) => <InitializePw {...props} />}
          />
          <Route
            path="/recovery-pw"
            render={(props) => <RecoveryPw {...props} />}
          />
          <Route
            path="/recovery-pwcode"
            render={(props) => <RecoveryPwCode {...props} />}
          />
          <Out>
            {/* <Helmet1 /> */}
            <Sidebar />
            <AccountInfo />
            {/* <InsideRoute /> */}
          </Out>
        </Switch>
      </Router>
    </>
  );
};

export const InsideRoute = () => {
  return (
    <>
      {/* <Route path="/dashBoard" render={(props) => <DashBoard {...props} />} /> */}
      <Route
        path="/historiesOrderings"
        render={(props) => <HistoriesOrderings {...props} />}
      />
      <Route
        path="/historiesOrders"
        render={(props) => <HistoriesOrders {...props} />}
      />
      <Route
        path="/HistoriesTransactions"
        render={(props) => <HistoriesTransactions {...props} />}
      />
      <Route
        path="/HistoriesAffiliates"
        render={(props) => <HistoriesAffiliates {...props} />}
      />
      <Route
        path="/exch-market"
        render={(props) => <ExchMarket {...props} />}
      />
      {/* <Route
        path="/exch-simple"
        render={(props) => <ExchSimple {...props} />}
      /> */}
      <Route
        path="/exch-advanced"
        render={(props) => <ExchAdvanced {...props} />}
      />
      <Route path="/pay" render={(props) => <Pay {...props} />} />
      <Route path="/settings" render={(props) => <Settings {...props} />} />
    </>
  );
};

const Out = (props) => {
  // || reduce_get_accounts.isLoading

  const reduce_post_authin = useSelector((state) => state.reduce_post_authin);

  if (reduce_post_authin.token) {
    return props.children;
  } else {
    return <Redirect to="/signin" />;
  }
};
